// import React from "react";
// import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
// import GroupIcon from "@mui/icons-material/Group";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import MoneyOffIcon from "@mui/icons-material/MoneyOff";
// import BlockIcon from "@mui/icons-material/Block";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import CountUp from "react-countup";
// import useStore from "../../useStore";

// function CollectionCount() {
//   const { dashboardDetails } = useStore();
//   console.log(dashboardDetails);

//   const sections = [
//     {
//       title: "Pigmy",
//       items: [
//         {
//           title: "Pigmy Collection Amount",
//           icon: <GroupIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.pigmyCollectionAmount || 0,
//         },
//         {
//           title: "Group Pigmy Collection Amount",
//           icon: <GroupIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.pigmyCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Daily Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.dailyLoanEmiCollection || 0,
//         },
//         {
//           title: "Penalty Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.dailyLoanPenaltyCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.dailyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Weekly Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanEmiCollection || 0,
//         },
//         {
//           title: "Penalty Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanPenaltyCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Monthly Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanEmiCollection || 0,
//         },

//         {
//           title: "Interest Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanInterestCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Individual Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanEmiCollection || 0,
//         },
//         {
//           title: "Penalty Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanPenaltyCollection || 0,
//         },
//         {
//           title: "Interest Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanInterestCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Group Weekly Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanEmiCollection || 0,
//         },
//         {
//           title: "Penalty Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanPenaltyCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Group Monthly Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanEmiCollection || 0,
//         },

//         {
//           title: "Interest Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanInterestCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Group Loan",
//       items: [
//         {
//           title: "EMI Collection",
//           icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanEmiCollection || 0,
//         },
//         {
//           title: "Penalty Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.weeklyLoanPenaltyCollection || 0,
//         },
//         {
//           title: "Interest Collection",
//           icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanInterestCollection || 0,
//         },
//         {
//           title: "Total",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.monthlyLoanCollectionAmount || 0,
//         },
//       ],
//     },
//     {
//       title: "Other",
//       items: [
//         {
//           title: "Processing Fee",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.processingFee || 0,
//         },
//         {
//           title: "Total Collection Amount",
//           icon: <BlockIcon sx={{ color: "#3352c6" }} />,
//           amount: dashboardDetails?.totalCollectionAmount || 0,
//         },
//       ],
//     },
//   ];

//   return (
//     <Grid container spacing={2}>
//       {sections.map((section, sectionIndex) => (
//         <Grid item xs={12} key={sectionIndex}>
//           <Typography variant="h5" sx={{ mt: 2, mb: 1, color: "#3352c6" }}>
//             {section.title}
//           </Typography>
//           <Grid container spacing={2}>
//             {section.items.map((item, index) => (
//               <Grid item xs={3} key={index}>
//                 <Card elevation={3} sx={{ borderRadius: 3 }}>
//                   <CardContent>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                       }}
//                     >
//                       <Typography variant="h6">{item.title}</Typography>
//                     </Box>
//                     <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
//                       <CurrencyRupeeIcon
//                         sx={{ fontSize: "16px", color: "#000" }}
//                       />
//                       <Typography variant="h6" sx={{ color: "#5252ff" }}>
//                         <CountUp start={900} end={item.amount} duration={2} />
//                       </Typography>
//                     </Box>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Grid>
//       ))}
//     </Grid>
//   );
// }

// export default CollectionCount;

// // export default CollectionCount;
// // import React from "react";
// // import { Box, Typography, Paper } from "@mui/material";
// // import { Bar } from "react-chartjs-2";
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   Title,
// //   Tooltip,
// //   Legend,
// // } from "chart.js";
// // import useStore from "../../useStore";

// // // Register Chart.js components
// // ChartJS.register(
// //   CategoryScale,
// //   LinearScale,
// //   BarElement,
// //   Title,
// //   Tooltip,
// //   Legend
// // );

// // function CollectionCount() {
// //   const { dashboardDetails } = useStore();

// //   // Bar chart data
// //   const data = {
// //     labels: [
// //       "Pigmy",
// //       "Loan",
// //       "Interest",
// //       "Penalty",
// //       "Daily",
// //       "Weekly",
// //       "Monthly",
// //       "Processing Fee",
// //       "G Pigmy",
// //       "G Loan",
// //       "Total",
// //     ],
// //     datasets: [
// //       {
// //         label: "Collection Amount",
// //         data: [
// //           dashboardDetails?.pigmyCollectionAmount || 0,
// //           dashboardDetails?.loanCollectionAmount || 0,
// //           dashboardDetails?.interestCollection || 0,
// //           dashboardDetails?.penaltyCollection || 0,
// //           dashboardDetails?.dailyLoanCollectionAmount || 0,
// //           dashboardDetails?.weeklyLoanCollectionAmount || 0,
// //           dashboardDetails?.monthlyLoanCollectionAmount || 0,
// //           dashboardDetails?.processingFee || 0,
// //           dashboardDetails?.groupPigmyCollection || 0,
// //           dashboardDetails?.groupLoanCollection || 0,
// //           dashboardDetails?.totalCollectionAmount || 0,
// //         ],
// //         backgroundColor: ["#5252ff"],
// //         borderRadius: 3,
// //         borderWidth: 1,
// //         barPercentage: 10,
// //         barThickness: 20,
// //       },
// //     ],
// //   };

// //   // Bar chart options
// //   const options = {
// //     responsive: true,
// //     plugins: {
// //       legend: {
// //         position: "top",
// //         labels: {
// //           font: {
// //             size: 10,
// //           },
// //         },
// //       },
// //       title: {
// //         display: true,
// //         text: "Collection Overview",
// //         font: {
// //           size: 10,
// //         },
// //       },
// //     },
// //     // scales: {
// //     //   x: {
// //     //     ticks: {
// //     //       font: {
// //     //         size: 12,
// //     //       },
// //     //     },
// //     //   },
// //     //   y: {
// //     //     ticks: {
// //     //       font: {
// //     //         size: 12,
// //     //       },
// //     //     },
// //     //   },
// //     // },
// //   };

// //   return (
// //     <Paper
// //       elevation={4}
// //       sx={{
// //         padding: 3,
// //         margin: 1,
// //         backgroundColor: "#fff",
// //         borderRadius: 3,
// //       }}
// //     >
// //       <Box sx={{ width: "100%" }}>
// //         {/* <Typography
// //           variant="h4"
// //           sx={{
// //             mb: 3,
// //             textAlign: "center",
// //             fontWeight: "bold",
// //             color: "#5252ff",
// //           }}
// //         >
// //           Collection Details
// //         </Typography> */}
// //         <Bar data={data} options={options} />
// //       </Box>
// //     </Paper>
// //   );
// // }

// //export default CollectionCount;
import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import BlockIcon from "@mui/icons-material/Block";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CountUp from "react-countup";
import useStore from "../../useStore";

function CollectionCount() {
  const { dashboardDetails } = useStore();

  const sections = [
    {
      title: "Pigmy",
      items: [
        {
          title: "Pigmy Collection Amount",
          icon: <GroupIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalPigmyCollectedAmount || 0,
        },
        {
          title: "Group Pigmy Collection Amount",
          icon: <GroupIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupPigmyCollectedAmount || 0,
        },
        {
          title: "Account Opening Fee",
          icon: <GroupIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalAccountOpeningAmount || 0,
        },
      ],
    },
    {
      title: "Daily Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalDailyEmiCollectedAmount || 0,
        },
        {
          title: "Penalty Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalDailyPenaltyCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <BlockIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalDailyCollection || 0,
        },
      ],
    },
    {
      title: "Weekly Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalWeeklyEmiCollectedAmount || 0,
        },
        {
          title: "Penalty Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalWeeklyPenaltyCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <BlockIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalWeeklyCollection || 0,
        },
      ],
    },
    {
      title: "Monthly Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalMonthlyEmiCollectedAmount || 0,
        },
        {
          title: "Interest Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalMonthlyInterestCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <BlockIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalMonthlyCollection || 0,
        },
      ],
    },
    {
      title: "Individual Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalLoanEmiCollection || 0,
        },
        {
          title: "Penalty Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalLoanPenaltyCollection || 0,
        },
        {
          title: "Interest Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalMonthlyInterestCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalLoanCollection || 0,
        },
      ],
    },
    {
      title: "Group Weekly Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupWeeklyEmiCollectedAmount || 0,
        },
        {
          title: "Penalty Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupWeeklyPenaltyCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <BlockIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalWeeklyGroupCollection || 0,
        },
      ],
    },
    {
      title: "Group Monthly Loan",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupMonthlyEmiCollectedAmount || 0,
        },
        {
          title: "Interest Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount:
            dashboardDetails?.totalGroupMonthlyInterestCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalMonthlyGroupCollection || 0,
        },
      ],
    },
    {
      title: "Group Loan Collection",
      items: [
        {
          title: "EMI Collection",
          icon: <AttachMoneyIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupLoanEmiCollection || 0,
        },
        {
          title: "Penalty Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupWeeklyPenaltyCollectedAmount || 0,
        },
        {
          title: "Interest Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount:
            dashboardDetails?.totalGroupMonthlyInterestCollectedAmount || 0,
        },
        {
          title: "Total Collection",
          icon: <MoneyOffIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalGroupCollection || 0,
        },
      ],
    },
    {
      title: "Other",
      items: [
        {
          title: "Total Collection Amount",
          icon: <BlockIcon sx={{ color: "#3352c6" }} />,
          amount: dashboardDetails?.totalCollectionAmount || 0,
        },
      ],
    },
  ];

  return (
    <Grid container spacing={2}>
      {sections.map((section, sectionIndex) => (
        <Grid item xs={12} key={sectionIndex}>
          <Typography variant="h5" sx={{ mt: 2, mb: 1, color: "#3352c6" }}>
            {section.title}
          </Typography>
          <Grid container spacing={2}>
            {section.items.map((item, index) => (
              <Grid item xs={3} key={index}>
                <Card elevation={3} sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h6">{item.title}</Typography>
                    </Box>
                    <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
                      <CurrencyRupeeIcon
                        sx={{ fontSize: "16px", color: "#000" }}
                      />
                      <Typography variant="h6" sx={{ color: "#5252ff" }}>
                        <CountUp start={900} end={item.amount} duration={2} />
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}

export default CollectionCount;
